// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RJaF","rootNoMargin":"styles_rootNoMargin__1jdKx"};